import type { Router } from 'vue-router';
import { useProductStockStore } from '../stores/productStock';

export const useProductStockRefresh = (router: Router) => {
  const { refreshStock } = useProductStockStore();
  const isPaginatedRequest = new URLSearchParams(window.location.search).has('page');

  if (isPaginatedRequest) refreshStock({ force: true });

  router.afterEach(() => {
    refreshStock();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshStock();
  });
};
